<template>
  <div>{{ texts.unknown_question_type }}</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('survey')

export default {
  name: 'Undefined',

  computed: {
    ...mapGetters(['texts']),
  },
}
</script>
